angular.module('picmonicng').component('homeStudyScheduler', {
  templateUrl: '/templates/app/components/home-study-scheduler/home-study-scheduler.html',
  bindings: {},
  controller: [
    '$scope',
    'UserService',
    'StudySchedulerModal',
    'studyplansResource',
    'PicmonicQueue',
    '$state',
    '$q',
    'SalesforceChatService',
    '$document',
    '$modal',
    '$location',
    function (
      $scope,
      UserService,
      StudySchedulerModal,
      studyplansResource,
      PicmonicQueue,
      $state,
      $q,
      SalesforceChatService,
      $document,
      $modal,
      $location
    ) {
      var ctrl = this;
      ctrl.showTopics = false;
      ctrl.showDetailedStudyPlan = false;
      ctrl.studyPlanLoading = false;
      ctrl.expansionDirection = false;
      ctrl.isV2 = $document.find('body').hasClass('v2-nav');
      ctrl.isLightMode = $document.find('body').hasClass('light');
      ctrl.isFreeTrial = UserService.user.is_trial;
      ctrl.isFreeTrialExpired = ctrl.isFreeTrial && UserService.user.free_trial_expiration < Date.now() / 1000;
      ctrl.isDemoStudyPlan = false;
      ctrl.upgradeType = 'study_scheduler';

      ctrl.postExamSurvey = {
        feel: null,
        use_again: null,
        frustrating: '',
        like: '',
      };

      ctrl.postExamSurveyValidationError = {
        feel: false,
        use_again: false,
      };

      ctrl.postExamSurveyFeelOptions = [
        { icon: 'sentiment_satisfied_alt', value: 'good', text: 'Good' },
        { icon: 'sentiment_satisfied', value: 'ok', text: 'Ok' },
        { icon: 'sentiment_very_dissatisfied', value: 'bad', text: 'Bad' },
      ];

      const storage = globalThis?.sessionStorage;
      if (!storage) return;

      const currentPath = globalThis.location.pathname;
      const prevPath = storage.getItem('currentPath') || '/';

      // If happened reload page - return
      if (currentPath !== prevPath) {
        // Set the previous path as the value of the current path.
        storage.setItem('prevPath', prevPath);
        // Set the current path value by looking at the browser's location object.
        storage.setItem('currentPath', currentPath);
      }

      ctrl.getStudyPlans = function () {
        if (ctrl.loading) {
          return;
        }

        ctrl.loading = true;
        ctrl.studyPlans = studyplansResource.query();
        ctrl.studyPlans.$promise.then(
          function () {
            ctrl.loading = false;

            if (ctrl.studyPlans.length) {
              // If you already have a selected study plan let's attempt to set that as your active study plan
              match = false;

              if (UserService.user.settings.active_studyplan) {
                angular.forEach(ctrl.studyPlans, function (studyPlan) {
                  if (UserService.user.settings.active_studyplan === studyPlan.studyplan_id) {
                    ctrl.processStudyPlan(studyPlan);
                    match = true;
                  }
                });
              }

              // Set your active study plan if you don't have one set already
              if (!match) {
                ctrl.processStudyPlan(ctrl.studyPlans[0]);
                UserService.user.settings.active_studyplan = ctrl.studyPlans[0].studyplan_id;
                UserService.user.$update();
              }
            }
          },
          function () {
            ctrl.loading = false;
          }
        );
      };

      ctrl.processStudyPlan = function (result) {
        ctrl.studyPlan = result;
        ctrl.isDemoStudyPlan = result.is_demo;

        var today = moment().hour(0).minutes(0).seconds(0);
        var testDate = moment(result.test_date * 1000).add(1, 'second');
        ctrl.daysUntilTest = testDate.diff(today, 'days');
        ctrl.postExamSurvey.studyplan_id = result.studyplan_id;

        if (ctrl.daysUntilTest < 0) {
          ctrl.daysUntilTest = 0;
        }

        ctrl.activeStudyPlanId = result.studyplan_id;

        if (result.quiz_accuracy < 1) {
          ctrl.accuracy = '--';
        } else {
          ctrl.accuracy = result.quiz_accuracy + '%';
        }

        if (today.isAfter(testDate)) {
          ctrl.isDemoStudyPlan && ctrl.setPostExamSurveyField('feel', 'N/A');
          ctrl.complete = true;
          ctrl.studyPlanLoading = false;
          return $q.resolve();
        }

        if (!result.current_lesson) {
          ctrl.studyPlanLoading = false;
          return $q.resolve();
        }

        ctrl.cards = $scope.picmonics = studyplansResource.query({
          studyplan_id: result.studyplan_id,
          resource: 'cards',
        });
        ctrl.questions = studyplansResource.get({
          studyplan_id: result.studyplan_id,
          resource: 'questions',
        });

        return $q.all([ctrl.cards.$promise, ctrl.questions.$promise]).then(function () {
          ctrl.lesson_time = 0;

          angular.forEach(ctrl.cards, function (card) {
            ctrl.lesson_time = ctrl.lesson_time + card.audio_length + card.total_facts * 15;
          });

          ctrl.lesson_time = ctrl.lesson_time + 15 * ctrl.questions.facts.length;

          hours = Math.floor(ctrl.lesson_time / (60 * 60));
          mins = Math.floor(ctrl.lesson_time / 60) % 60;

          ctrl.lesson_time_string = (hours ? hours + ' hrs' : '') + ' ' + (mins ? mins + ' mins' : '');
        });
      };

      ctrl.getStudyPlan = function (studyplan_id, nextLesson) {
        if (ctrl.studyPlanLoading) {
          return;
        }

        ctrl.studyPlanLoading = true;

        studyplansResource.get({ studyplan_id: studyplan_id, next_lesson: nextLesson }, function (result) {
          ctrl.processStudyPlan(result).finally(function () {
            ctrl.studyPlanLoading = false;
          });
        });
      };

      ctrl.getStudyPlans();

      ctrl.show = function () {
        ctrl.thanks = false;
        StudySchedulerModal.show(ctrl, null, null, ctrl.studyPlans);
      };

      ctrl.$onInit = function () {
        if ($location.search().create === '1') {
          ctrl.show();
        }
      };

      ctrl.startLearn = function (startWith) {
        PicmonicQueue.setAndPlay(
          ctrl.cards,
          startWith && startWith.card_id ? startWith.card_id : null,
          true,
          undefined,
          undefined,
          undefined,
          ctrl.studyPlan.studyplan_id
        );
        atlasEvent('click', 'study scheduler - start learning');
      };

      ctrl.startQuiz = function () {
        $state.go('app.quiz', {
          quiz_type: 'studyplan',
          resource_id: ctrl.studyPlan.studyplan_id,
          questions: ctrl.studyPlan.current_lesson.facts_left,
        });
        atlasEvent('click', 'study scheduler - start smart review quiz');
      };

      ctrl.deleteStudyPlan = function () {
        $modal.open({
          animation: true,
          backdrop: 'static',
          templateUrl: '/templates/modals/delete-confirm.html',
          controller: [
            '$scope',
            '$modalInstance',
            'toaster',
            function ($scope, $modalInstance, toaster) {
              $scope.confirmation_text =
                'Are you sure you want to delete this study schedule? This action cannot be undone.';

              $scope.confirm = function () {
                studyplansResource.delete(
                  { studyplan_id: ctrl.studyPlan.studyplan_id },
                  function () {
                    ctrl.getStudyPlans();
                    $modalInstance.close();
                    toaster.success('', 'Study Schedule deleted.');
                  },
                  function () {
                    toaster.error('', 'Error deleting Study Schedule!');
                  }
                );
              };

              $scope.cancel = function () {
                $modalInstance.close();
              };
            },
          ],
        });
      };

      ctrl.toggleExpansion = function () {
        ctrl.expansionDirection = !ctrl.expansionDirection;

        angular.forEach(ctrl.studyPlan.weeks, function (week) {
          week.visible = ctrl.expansionDirection;
        });
        angular.forEach(ctrl.studyPlan.lessons, function (lesson) {
          lesson.cards_visible = ctrl.expansionDirection;
        });
      };

      ctrl.nextLesson = function () {
        ctrl.getStudyPlan(ctrl.studyPlan.studyplan_id, 1);
      };

      ctrl.setPostExamSurveyField = function (field, value) {
        ctrl.postExamSurvey[field] = value;
      };

      ctrl.submitPostExamSurvey = function () {
        if (ctrl.postExamSurveyLoading) {
          return;
        }

        ctrl.postExamSurveyValidationError.use_again = false;
        ctrl.postExamSurveyValidationError.feel = false;

        if (!ctrl.postExamSurvey.feel) {
          ctrl.postExamSurveyValidationError.feel = true;
        }
        if (!ctrl.postExamSurvey.use_again) {
          ctrl.postExamSurveyValidationError.use_again = true;
        }

        if (ctrl.postExamSurveyValidationError.feel || ctrl.postExamSurveyValidationError.use_again) {
          return;
        }

        ctrl.postExamSurveyLoading = true;

        studyplansResource.survey(
          ctrl.postExamSurvey,
          function () {
            ctrl.postExamSurveyLoading = false;
            ctrl.studyPlan = null;
            ctrl.studyPlans = [];
            ctrl.complete = false;
            ctrl.thanks = true;
            ctrl.getStudyPlans();
          },
          function () {
            ctrl.postExamSurveyLoading = false;
          }
        );
      };

      ctrl.learnSinglePicmonic = function (card) {
        PicmonicQueue.setAndPlay(
          [card],
          card.card_id,
          true,
          undefined,
          undefined,
          undefined,
          ctrl.studyPlan.studyplan_id
        );
      };

      ctrl.edit = function () {
        StudySchedulerModal.show(ctrl, ctrl.studyPlan, null, ctrl.studyPlans);
      };

      ctrl.switchStudyPlan = function () {
        angular.forEach(ctrl.studyPlans, function (studyPlan) {
          if (ctrl.activeStudyPlanId === studyPlan.studyplan_id) {
            ctrl.getStudyPlan(ctrl.activeStudyPlanId);
            UserService.user.settings.active_studyplan = ctrl.activeStudyPlanId;
            UserService.user.$update();
          }
        });
      };

      ctrl.print = function () {
        window.open('/api/v3/studyplans/' + ctrl.studyPlan.studyplan_id + '/print');
      };
    },
  ],
});
